'use client';

import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  FC,
} from 'react';

interface AccordionContextType {
  expanded: number | null;
  toggleAccordion: (index: number | null) => void;
}

const AccordionContext = createContext<AccordionContextType | undefined>(
  undefined,
);

interface AccordionProviderProps {
  children: ReactNode;
}

export const AccordionProvider: FC<AccordionProviderProps> = ({ children }) => {
  const [expanded, setExpanded] = useState<number | null>(null);

  const toggleAccordion = (index: number | null) => {
    setExpanded((prev) => (prev === index ? null : index));
  };

  return (
    <AccordionContext.Provider value={{ expanded, toggleAccordion }}>
      {children}
    </AccordionContext.Provider>
  );
};

// Hook for easy context consumption
export const useAccordion = () => {
  const context = useContext(AccordionContext);
  if (context === undefined) {
    throw new Error('useAccordion must be used within an AccordionProvider');
  }
  return context;
};
